import React from 'react';
import { Card } from 'react-bootstrap';

const SurveyOtherFilters = () => {
  return (
    <Card className="survey-info-card bg-gray">
      <Card.Header className="survey-info-card-header">
        Other Filters
      </Card.Header>
      <div className='p-4 text-center'>
        <b>This survey does not contain any other filters.</b>
      </div>
    </Card>
  );
};

SurveyOtherFilters.propTypes = {
};

SurveyOtherFilters.defaultProps = {};

export default SurveyOtherFilters;
